//============================================================================
// Name        : production_calendar.ts
// Purpose     : Production Calendar
// Created     : 2019-12-17

// Copyright   : Copyright 2018 Senitron Corporation. All rights reserved.
//============================================================================

declare var $;
declare var App;
declare var cellDataPath;
declare var createNewProductionPath;
declare var hideLoadingBox;
declare var loadingDialogBox;
declare var storeLocation: string;
declare var calendar: string;
declare var calendarState: string;
declare var closureReportPath: string;

export class ProductionCalendar {
    constructor() {
        App.production_calendar_update = App.cable.subscriptions.create(
            // Connection configuration
            {
                channel: "ProductionUpdateChannel",
                tenant: `${storeLocation}`,
                zone_id: `${calendar}`
            },

            // Pass in connection callbacks
            {
                connected: () => {
                    console.log("Production calendar channel connected");
                    // Called when the subscription is ready for use on the server
                },

                disconnected: () => {
                    // Called when the subscription has been terminated by the server
                },

                received: (data) => {
                    this.reloadCell(data.date, data.sub_zone_id);
                }
            }
        );
    }

    hideEmptyRows(){}

    initCells() {
        $(window).load( () => {
            this.loadCells();
            this.loadReports();
        });
    }

    refreshPage(){
        window.location.reload();
    }

    reloadCell(date, subZoneID) {
        this.loadCell(date, subZoneID);
        this.closureReport(date);
    }

    loadReports() {
        $(".report-cell").each((i, item) => {
            this.closureReport($(item).data("date"));
        });
    }

    closureReport(date) {
        const _table = $(".report-cell[data-date='" + date + "'");
        if(typeof closureReportPath === "undefined")
            return
        $.ajax({
            url: closureReportPath + "?date=" + date,
            success: (response) => {
            _table.html(response);
            }
        });
    }

    loadCells() {
        $(".data").each((i, item) => {
            this.loadCell($(item).data("date"), $(item).data("sub-zone-id"));
        });
    }

    loadNewProduction(el) {
        loadingDialogBox();
        $.get({
            url: createNewProductionPath,
            data: { date: $(el).data("date"), sub_zone_id: $(el).data("sub-zone-id") }
        }).complete( () => {
            hideLoadingBox();
        });
    }

    loadEditProduction(el) {
        const editUrl = $(el).data("edit-url");
        loadingDialogBox();
        $.get({url: editUrl}).complete( () => {
            hideLoadingBox();
        });
    }

    redirectToPrintTag(el) {
        const returnLocation = window.location.href;
        window.location.href = $(el).data("print-tag-url") + "&return_path=" + returnLocation + "";
    }

    redirectToConsumption(el) {
        const returnLocation = window.location.href;
        window.location.href = $(el).data("reconciliation-url"); //+ "?return_path=" + returnLocation + "";
    }

    loadCell(date: string, subZoneId: number) {
        const _element = $('.cell[data-date="' + date + '"][data-sub-zone-id="' + subZoneId + '"]');
        _element.html('<i class="fa fa-spinner fa-spin loading"></i>');
        var s_this = this;
        $.ajax({
            url: `${cellDataPath}`,
            data: { date, sub_zone_id: subZoneId },
            success: (response) => {
                s_this.renderCell(date, subZoneId, response.productions);
            },
            fail: (error) => {
                console.log(error);
                _element.html("");
            }
        });
    }

    renderCell(date: string, subZoneId: number, productions: any) {
        const _element = $('.cell[data-date="' + date + '"][data-sub-zone-id="' + subZoneId + '"]');
        let data = "";
        productions.forEach((e, index) => {
            data += "<div class='edit-wo' data-edit-url='" + e.edit_url + "' data-print-tag-url='" + e.print_tags_url + "' data-status='" + e.status + "'";
            data += "data-reconciliation-url='" + e.reconciliation_url + "'";
            if (calendarState == "") {
                data += " onclick='window.ProductionCalendar.loadEditProduction(this)'";
            } else if (calendarState == "workorder_productions") {
                if (e.status == "Closed") {
                    data += " onclick=";
                    data += "\"if (confirm('This WO is closed, Are you sure to print the labels again?'))"
                    data += " window.ProductionCalendar.redirectToPrintTag(this) \"";
                    console.log(data);
                } else {
                    data += " onclick='window.ProductionCalendar.redirectToPrintTag(this)'";
                }
            } else if (calendarState == "workorder_consumptions") {
                data += " onclick='window.ProductionCalendar.redirectToConsumption(this)'";
            }
            if (index != 0) {
                data += " style='border-top: 1px grey dashed'";
            }
            data += ">";
            data += "<b>" + e.production_item + "</b> ";
            data += "<b>" + e.start_time + "-" + e.end_time + "</b> ";
            if (e.line_item) {
                data += "WO" + e.id + " ";
            }
            data += " " + e.production_item + " " + e.product_name + " ";
            data += "<span class='red-note'>" + e.red_note + " </span>";
            data += " <i class='fa fa-user'></i> " + e.crew_size + " ";
            if (e.line_item) {
                data += "<i class='fa fa-signal'></i> " + e.upm;
            }
            if (e.variance_reason != "") {
                data += " <span style='color: orange'>" + e.variance_reason + "</span>";
            }

            if (e.allergens.length != 0) {
                data += "<a title='Allergens' href='#' data-allergens='"+ JSON.stringify(e.allergens) +"' onclick='window.ProductionCalendar.showAllergens(event, this)'>";
                data += "<i style='margin-left: 10px; color: red' class='fa fa-exclamation-circle'></i></a>";
            }
            data += "<br>";
            if (e.line_item) {
                data += "<b>" + parseInt(e.needed_qty, 10) + "</b> " + e.storage_unit_name + " ";
                data += "/ <b>" + parseInt(e.produced, 10) + "</b> " + e.storage_unit_name + " ";
                if (e.progress != 0.0) {
                    data += "<span class='label label-primary'>" + e.progress + "% </span>";
                } else {
                    if (e.staging_progress >= 95) {
                        data += "<span class='label label-success'> Staged & Ready </span>";
                    } else if (e.staging_progress != 0.0 ) {
                        data += "<span class='label label-primary'> Staging: " + e.staging_progress + "% </span>";
                    }
                }
                data += "<span class='label label-" + this.loadStatus(e.status) + "'>" + e.status + "</span>";
                if (e.status == "Closed") {
                    data += "<b> MV: " + this.muvColorCode(e.muv) + "</b>";
                }
            }
            data += "</div>";
        });
        if (calendarState == "") {
            data += "<span class='create-new-production' data-date='" + date + "' data-sub-zone-id='" + subZoneId + "' onclick='window.ProductionCalendar.loadNewProduction(this)'>";
            data += " <i class='fa fa-plus-circle add-new-production'>&nbsp;</i></span>";
        }
        _element.html(data);
    }

    muvColorCode(e: string) {
        if (e == "N/A") {
            return e;
        }
        else if (Number(e) < 0 ) {
            return `<span style='color: red'>${e}%</span>`;
        }
        else if (Number(e) >= 0 ) {
            return `<span style='color: green'>${e}%</span>`;
        }
    }

    loadStatus(e: string) {
        if (e == "Complete") {
            return "success";
        }
        else if (e == "in_process") {
            return "middle";
        }
        else if (e == "Open") {
            return "danger";
        }
        else if (e == "Closed") {
            return "closed";
        }
        else if (e == "Warning") {
            return "warning";
        }
        else if (e == "muted") {
            return "muted";
        }
        else {
            return "primary";
        }
    }

    showAllergens(event, el) {
      event.stopPropagation();
      const allergens = $(el).data("allergens");
      $('#allergensModal').modal('show');
      var tdContent = '';
      allergens.forEach((allergen) => {
        tdContent += "<tr><td>" + allergen.item_alu + "</td>" +
           "<td>" + (allergen.allergens != null ? allergen.allergens : '') + "</td>" +
           "<td>" + (allergen.tree_nuts != null ? allergen.tree_nuts : '') + "</td>" +
           "</tr>";
        $('#allergensModalTBody').html(tdContent);
      })
    }
}
